// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-confirm-order-confirm-81107 .icloud-ui-card{padding:0}.order-confirm-order-confirm-81107 .order-confirm-elasticPublicNetwork-901f6 .order-confirm-elasticPublicNetwork-detail-90547{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order-confirm": "order-confirm-order-confirm-81107",
	"orderConfirm": "order-confirm-order-confirm-81107",
	"elasticPublicNetwork": "order-confirm-elasticPublicNetwork-901f6",
	"elasticPublicNetwork-detail": "order-confirm-elasticPublicNetwork-detail-90547",
	"elasticPublicNetworkDetail": "order-confirm-elasticPublicNetwork-detail-90547"
};
export default ___CSS_LOADER_EXPORT___;
